<template>
  <el-dialog
    :title="mode === 'create' ? '新增题目' : '编辑题目'"
    :visible.sync="dialogVisible"
    width="800px"
    append-to-body
    @close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="题目类型" prop="type">
        <el-radio-group v-model="form.type" @change="handleTypeChange">
          <el-radio :label="QUESTION_TYPE.SINGLE_CHOICE">{{
            QUESTION_TYPE_MAP[QUESTION_TYPE.SINGLE_CHOICE]
          }}</el-radio>
          <el-radio :label="QUESTION_TYPE.MULTIPLE_CHOICE">{{
            QUESTION_TYPE_MAP[QUESTION_TYPE.MULTIPLE_CHOICE]
          }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="题目分数" prop="score">
        <el-input-number
          v-model="form.score"
          :min="1"
          :max="100"
          placeholder="分数"
          style="width: 200px"
        />
        <span style="margin-left: 10px; color: #909399">分</span>
      </el-form-item>

      <el-form-item label="题目内容" prop="question">
        <el-input v-model="form.question" type="textarea" :rows="3" placeholder="请输入题目内容" />
      </el-form-item>

      <el-form-item label="题目附件">
        <multiple-file-upload
          v-model="form.medias"
          :bucket="ossBucket"
          :filePath="ossQuestionFilePath"
          simpleData
          :limit="10"
        />
      </el-form-item>

      <el-form-item label="题目选项" prop="options">
        <div class="options-section">
          <div class="options-header">
            <el-button type="primary" size="small" @click="handleAddOption">
              <i class="el-icon-plus"></i>
              添加选项
            </el-button>
            <span class="options-tip">
              {{
                form.type === QUESTION_TYPE.SINGLE_CHOICE
                  ? "单选题只能有一个正确答案"
                  : "多选题可以有多个正确答案"
              }}
            </span>
          </div>

          <div v-if="form.options && form.options.length > 0" class="options-list">
            <div v-for="(option, index) in form.options" :key="index" class="option-item">
              <div class="option-content">
                <el-input
                  v-model="option.id"
                  placeholder="选项ID"
                  style="width: 80px; margin-right: 10px"
                  disabled
                />
                <el-input
                  v-model="option.content"
                  placeholder="选项内容"
                  style="flex: 1; margin-right: 10px"
                />
                <el-button size="mini" @click="handleUploadOptionFile(index)" style="width: 80px">
                  {{
                    option.medias && option.medias.length > 0
                      ? `附件(${option.medias.length})`
                      : "附件"
                  }}</el-button
                >
              </div>
              <div class="option-actions">
                <el-button size="mini" type="danger" @click="handleRemoveOption(index)"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="正确答案" prop="answer">
        <div class="answer-section">
          <el-checkbox-group v-model="form.answer">
            <el-checkbox v-for="option in form.options" :key="option.id" :label="option.id">
              {{ option.id }}. {{ option.content }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form-item>

      <el-form-item label="题目解析" prop="explanation">
        <el-input
          v-model="form.explanation"
          type="textarea"
          :rows="3"
          placeholder="请输入题目解析（可选）"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleConfirm"> 确定 </el-button>
    </div>

    <!-- 选项图片上传对话框 -->
    <el-dialog
      title="上传选项图片"
      :visible.sync="optionFileDialogVisible"
      width="500px"
      append-to-body
    >
      <multiple-file-upload
        v-model="currentFiles"
        :bucket="ossBucket"
        :filePath="ossOptionFilePath"
        simpleData
        :limit="3"
      />

      <div slot="footer" class="dialog-footer">
        <el-button @click="optionFileDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleUploadOptionFileConfirm">确定</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { QUESTION_TYPE, QUESTION_TYPE_MAP } from "@/core/const/global-const";

import _ from "lodash";
export default {
  name: "QuestionDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: String,
      default: "create" // create | edit
    }
  },
  data() {
    return {
      QUESTION_TYPE,
      QUESTION_TYPE_MAP,
      dialogVisible: false,
      ossQuestionFilePath: "/new_training/exam",
      ossOptionFilePath: "/new_training/exam/option",
      ossBucket: "yxmgt-private",
      form: {
        type: QUESTION_TYPE.SINGLE_CHOICE,
        question: "",
        score: 10,
        medias: [],
        options: [],
        answer: [],
        explanation: ""
      },
      rules: {
        type: [{ required: true, message: "请选择题目类型", trigger: "change" }],
        question: [{ required: true, message: "请输入题目内容", trigger: "blur" }],
        score: [{ required: true, message: "请输入题目分数", trigger: "blur" }],
        options: [{ required: true, message: "请添加题目选项", trigger: "blur" }],
        answer: [{ required: true, message: "请选择正确答案", trigger: "change" }]
      },

      // 文件上传相关
      optionFileDialogVisible: false,
      currentOptionIndex: -1,
      currentFiles: []
    };
  },
  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val;
        if (val) {
          this.initForm();
        }
      },
      immediate: true
    }
  },
  methods: {
    // 初始化表单
    initForm() {
      if (this.mode === "create") {
        this.form = {
          type: QUESTION_TYPE.SINGLE_CHOICE,
          question: "",
          score: 10,
          medias: [],
          options: [],
          answer: [],
          explanation: ""
        };
        this.addDefaultOptions();
      } else {
        this.form = _.cloneDeep(this.formData);
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },

    // 添加默认选项
    addDefaultOptions() {
      this.form.options = [
        { id: "A", content: "", medias: [] },
        { id: "B", content: "", medias: [] },
        { id: "C", content: "", medias: [] },
        { id: "D", content: "", medias: [] }
      ];
    },

    // 题目类型变化
    handleTypeChange(type) {
      this.form.answer = [];
      if (type === QUESTION_TYPE.SINGLE_CHOICE && this.form.options.length === 0) {
        this.addDefaultOptions();
      }
    },

    // 添加选项
    handleAddOption() {
      const optionId = String.fromCharCode(65 + this.form.options.length); // A, B, C, D...
      this.form.options.push({
        id: optionId,
        content: "",
        medias: []
      });
      // 清除相关答案
      this.$set(this.form, "answer", []);
    },

    // 删除选项
    handleRemoveOption(index) {
      if (this.form.options.length <= 2) {
        this.$message.warning("至少需要2个选项");
        return;
      }
      this.form.options.splice(index, 1);
      // 重新生成选项ID
      this.form.options.forEach((option, index) => {
        option.id = String.fromCharCode(65 + index);
      });
      // 清除相关答案
      this.$set(this.form, "answer", []);
    },

    // 上传选项附件
    handleUploadOptionFile(index) {
      this.currentOptionIndex = index;
      this.currentFiles = this.form.options[index].medias;
      this.optionFileDialogVisible = true;
    },

    // 上传选项附件确认
    handleUploadOptionFileConfirm() {
      this.optionFileDialogVisible = false;
      this.form.options[this.currentOptionIndex].medias = this.currentFiles;
    },

    // 确认
    handleConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          // 验证选项内容
          const hasEmptyOption = this.form.options.some((option) => !option.content.trim());
          if (hasEmptyOption) {
            this.$message.warning("请填写所有选项内容");
            return;
          }

          // 验证答案
          if (this.form.answer.length === 0) {
            this.$message.warning("请选择正确答案");
            return;
          }

          if (this.form.type === QUESTION_TYPE.SINGLE_CHOICE && this.form.answer.length > 1) {
            this.$message.warning("单选题只能选择一个正确答案");
            return;
          }

          try {
            // 生成题目ID
            const questionData = {
              ...this.form,
              id: this.mode === "create" ? "q" + Date.now() : this.form.id
            };

            this.$emit("confirm", questionData);
            this.handleClose();
          } catch (error) {
            this.$message.error("保存失败");
            console.error(error);
          }
        }
      });
    },

    // 关闭
    handleClose() {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style lang="less" scoped>
.upload-tip {
  margin-top: 8px;
  color: #909399;
  font-size: 12px;
}

.options-section {
  .options-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .options-tip {
      color: #909399;
      font-size: 12px;
    }
  }

  .options-list {
    .option-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      padding: 12px;
      border: 1px solid #e4e7ed;
      border-radius: 4px;

      .option-content {
        display: flex;
        align-items: center;
        flex: 1;
      }

      .option-actions {
        margin-left: 16px;
      }
    }
  }
}

.answer-section {
  .el-checkbox-group {
    .el-checkbox {
      display: block;
      margin-bottom: 12px;
      margin-right: 0;
    }
  }
}

.dialog-footer {
  text-align: right;
}
</style>
